import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {Col, Row} from "react-bootstrap";
import Api from "../Api.js";
import {useLocation, useParams} from "react-router-dom";
import {word} from '../word.js';
import userbig from "../assets/img/userbig.png";
import qs from "query-string";
import EditManager from "../components/EditManager.js";
import OrganizationItem from "../components/OrganizationItem.js";
function Employee() {
    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const {id} = useParams();
    const [show, setShow] = useState(false);
    const [org, setOrg] = useState([]);
    const [accountant, setAccountant] = useState({});


    useEffect(() => {
        (async () => {
            await fetchEmployeeData();
            await fetchAccountantCompany();
        })()

    }, []);
    const fetchEmployeeData = async () => {
        try {
            if(query && query.manager){
                const {data} = await Api.managerUpdateGet('manager',id);
                setAccountant(data)
            }else{
                const {data} = await Api.managerUpdateGet('accountant',id);
                setAccountant(data)
            }

        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    };

    const fetchAccountantCompany = async () => {
        try {
            if(query && query.manager){
                const {data} = await Api.getConnectedCompanies('manager',id,1000);
                setOrg(data.results)
            }else{
                const {data} = await Api.getConnectedCompanies('accountant',id,1000);
                setOrg(data.results)
            }
        } catch (error) {
            console.error("Error fetching accountant company data:", error);
        }
    };


    return (
        <Wrapper>
            <div className='my-user-org-page'>
                <div className='header-line'/>
                <div className='modules-header'/>
                <div className='my-page-cont'>
                    <div className='container'>
                        <Row className='img-name'>
                            <div className='image-round'>
                                <div className='my-personal-image' style={{ backgroundImage: accountant?.image ? `url(${accountant?.image})` : `url(${userbig})` }}/>
                            </div>
                            <h1>{accountant?.user?.first_name}<br /> {accountant?.user?.last_name}</h1>
                        </Row>
                        <div className='data-section'>
                            <div className='container'>
                                <p className='data-section'>{word.personal_information}</p>
                                <div className="edit-delete-cont">
                                    <div className="tool-tip-cont">
                                        <div className="tool-tip">Խմբագրել</div>
                                        <span onClick={() => setShow(true)} className='icon-Compose'/>
                                    </div>
                                </div>
                                <Row className="my-data flex-nowrap">
                                    <Col xs={6} sm={6}>
                                        <p className='data-line'>{word._name}</p>
                                        <p className='data-line'>{word.surname}</p>
                                        <p className='data-line'>Դասընթացներին ներգրավված անձ</p>
                                        {query.manager?null:<p className='data-line'>{word.profession}</p>}
                                        <p className='data-line'>{word.phone}</p>
                                        <p className='data-line'>{word.email}</p>
                                    </Col>
                                    <Col xs={6} sm={6}>
                                        <p className='data-line'><span>{accountant?.user?.first_name}</span></p>
                                        <p className='data-line'>{accountant?.user?.last_name}</p>
                                        <p className='data-line'>{accountant?.is_lecturer ? "Այո" : "Ոչ"}</p>
                                        {query.manager?null:<p className='data-line'>{accountant?.profession !== "null" ? accountant?.profession : ""}</p>}
                                        <p className='data-line'>{accountant?.phone}</p>
                                        <p className='data-line'>{accountant?.user?.email}</p>
                                    </Col>
                                </Row>
                                <p className='data-section'>{word.my_organizations}</p>
                                <Row className='org-section'>
                                    {org.map((item, index) => (
                                        <OrganizationItem key={index} id={item.id} is_deleted={item.is_deleted}
                                                          orgname={item.name} name={item.director_full_name}
                                                          HVHH={item.HVHH} logo={item.logo} />
                                    ))}
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {show?<EditManager setInfo={setAccountant} information={accountant} show={show} onHide={() => setShow(false)}/>:null}
        </Wrapper>
    );
}

export default Employee;